import styled, { css } from 'styled-components'
import { colors, fonts } from '../Styles/common-styles'
import { Timeline, Steps } from 'rsuite'

const onCompletedStyles = {
  flexColumn: {
    display: 'flex', flexDirection: 'column', alignItems: 'center'
  },
  title: {
    marginTop: '77px', fontSize: '24px', fontWeight: '600', lineHeight: '24px', letterSpacing: '0px'
  },
  span: {
    margin: '26px 152px 0px', fontSize: '16px', fontWeight: '400', lineHeight: '22,4px', letterSpacing: '0px', textAlign: 'center'
  },
  image: {
    marginTop: '87px'
  },
  flexRow: {
    marginTop: '130px', justifyContent: 'space-between'
  },
  flexRowCenter: {
    marginTop: '130px', justifyContent: 'center'
  },
  button: {
    marginTop: '38px',
    toUncompleted: {
      marginLeft: '24px',
      marginTop: '38px'
    }
  }
}

const Container = styled.div`
  height: 765px;
  display: flex;
  justify-content: center;
  align-items: center;
`
const H1 = styled.h1`
  display: flex;
  font-size: ${fonts.extraLargeSize};
  font-weight: 600;
  line-height: ${fonts.extraLargeSize};
  color: ${colors.black}
`
const H2 = styled.h2`
  font-size: 17px;
  font-weight: 600;
  line-height: ${fonts.extraLargeSize};
  letter-spacing: 0px;
  text-align: left;
  margin-bottom: 6px;
`
const P1 = styled.p`
  font-size: ${fonts.largeSize};
  font-style: normal;
  font-weight: 600;
  line-height: 21px;
  letter-spacing: 0px;
  text-align: left;
`

const P2 = styled.p`
  font-size: ${fonts.largeSize};
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0px;
  text-align: left;
`

const TitleDiv = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 28px 0px;
`
const FlexH = styled.div`
  display: flex;
`

const FlexV = styled.div`
  display: 'flex';
  flex-direction: 'column';
`

const EventState = styled.span`
  display: flex;
  font-size: ${fonts.largeSize};
  font-weight: 400;
  line-height: 22.4px;
  margin-left: 37px;
  color: ${colors.grey}
`

const StepsTitle = styled.span`
  font-size: ${fonts.largeSize};
  font-weight: 400;
  line-height: 22.4px;
  color: ${colors.black};
  display: flex;
  align-items: center;
`

const StepsContainer = styled.div`
  overflow-y: scroll;
  border-radius: 8px;
  width: 753px;
  height: 514px;
  margin-top: 24px;
  ::-webkit-scrollbar {
    width: 0px;
  }
}
`
const FullStep = styled.div`
  // display: flex;
  border-radius: 8px;
  margin-bottom: 22px;
  padding: 10px 12px;
  cursor: pointer;
  ${props => props.highlight && css`background-color: ${colors.highlighter}`};
`
const StepNumber = styled.span`
  color: ${colors.pink};
  font-weight: 600;
  font-size: ${fonts.bigSize};
  line-height: 140%;
`
const StepText = styled.span`
  font-size: ${fonts.largeSize};
  font-weight: 400;
  line-height: 22.4px;
  color: ${colors.black};
  margin-left: 12px;
`
const DescriptionDiv = styled.div`
  width: 800px;
  height: 676px;
  margin-left: 34px;
  border-radius: 8px;
  border: 1px solid ${colors.stroke};
  background: ${colors.white};
`
const CompletedText = styled.div`
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 400;
  line-height: 19px;
  letter-spacing: 0px;
  color: ${colors.green}
`

const ButtonsDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 273px;
  height: 40px;
`
const BackNextButton = styled.button`
  display: flex;
  background: transparent;
  font-size: ${fonts.smallSize};
  font-weight: 600;
  line-height: 12.78px;
  color: ${colors.purpleBright};
`

const BodyDiv = styled.div`
  display: flex;
  justify-content: space-between;
`

const DescriptionTitle = styled.span`
  color: ${colors.black};
  font-size: ${fonts.bigSize};
  font-weight: 600;
  line-height: 28px;
`

const Duration = styled.span`
  color: ${colors.grey};
  font-size: ${fonts.normalSize};
  font-weight: normal;
  line-height: 140%;
  display: flex;
  align-items: center;
  margin-right: 22px;
`

const Timer = styled.span`
  color: ${colors.purpleMain};
  font-style: normal;
  font-weight: 600;
  font-size: ${fonts.extraBigSize};
  line-height: 140%;
  display: flex;
  align-items: center;
  text-align: right;
`

const MyTimelineItem = styled(Timeline.Item)`
  margin-left: -42px;

  .rs-timeline-item-dot::before{
  border: solid 0.1px;
  border-color: ${colors.grey};
  width: 18px;
  height: 18px;
  left: -2px;
  ${props => props.done ? css`background-color: ${colors.purpleBright}` : css`background-color: ${colors.white}`};
},

item-content {
  ${props => props.current && css`color: ${colors.purpleBright}`};
  padding-top: 2px;
},

.rs-timeline-item:not(:last-child), .rs-timeline-item-content {
  padding-left: 13px;
},

.rs-steps-vertical .rs-steps-item {
  padding-bottom: 0px;
},

.rs-timeline-item-tail {
  left: 9px;
  width: 1px;
},

.rs-timeline-item {
  width: 263px;
  height: 28px;
  white-space: nowrap;
  ${props => props.current && css`background-color: ${colors.highlighter}`};
},

.rs-timeline-item, .sc-hgZQmf, .dFXVhb, .rs-timeline-item-last{
  cursor: pointer;
}
`

const MyStepItem = styled(Steps.Item)`

.rs-steps-item-icon-wrapper > .rs-steps-item-icon {
  cursor: pointer;
},

.rs-steps-item-title {
  cursor: pointer;
},

.rs-steps-vertical, .rs-steps-item-tail {
  border-left-width: 0px;
},

.rs-steps-item-status-process, .rs-steps-item-icon-wrapper:not(.rs-steps-item-custom-icon) {
  background-color: ${colors.white};
  color: ${colors.grey};
  border-color: ${colors.grey};
  white-space: nowrap;
  ${props => props.current && css`background-color: ${colors.white}; color: ${colors.purpleBright};`};
  ${props => props.done && css`background-color: ${colors.purpleMain}; color: ${colors.white};`};
},

rs-steps-item-icon-wrapper {
  background: transparent;
},

.rs-steps-item-title {
  color: ${colors.grey};
  ${props => props.done && css`color: ${colors.black}`};
  ${props => props.current && css`color: ${colors.purpleMain}`};
}
`

export {
  onCompletedStyles, MyStepItem, MyTimelineItem, Container, H1, H2, P1, P2, TitleDiv, FlexH, FlexV,
  EventState, StepsTitle, StepsContainer, FullStep, StepNumber, StepText, DescriptionDiv,
  ButtonsDiv, BackNextButton, BodyDiv, DescriptionTitle, Duration, Timer, CompletedText
}
